/* eslint-disable camelcase, no-console, space-before-function-paren */
import { Widget } from "blue-widgets";
import { parser, registry } from "blue-widgets";
import Wizard from "../tools/wizard";
// https://github.com/AdrianVillamayor/Wizard-JS

class WizardHelper extends Widget {
  static wizardReady = false;

  constructor(el) {
    super(el);
    this.btnHtml = "Next<i aria-hidden='true' class='icon icon-arrow-right'/>";
    this.checkboxChecked = false;
    this.isResultsPage = this.el.hasAttribute("data-results-page");

    this.init();
  }

  init() {
    if (this.isResultsPage) {
      this.closeBtn = this.el.querySelector("[data-close-btn]");
      this.closeBtn.addEventListener("click", this.handleCloseClick);
      return;
    }

    if (!WizardHelper.wizardReady) {
      WizardHelper.wizard = new Wizard({
        wz_class: ".wizard__form",
        wz_step: ".wizard__step",
        wz_buttons: ".wizard__buttons",
        highlight: false,
        next: this.btnHtml,
        finish: this.btnHtml,
        nav: false,
        wz_button: ".button",
        wz_content: ".wizard__content"
      });
      WizardHelper.wizard.init();

      // Re-parse the main content to ensure widgets are initialized
      const main = document.querySelector("main");
      registry.destroyDescendants(main);
      parser.parse(main);
    }

    this.closeBtn = this.el.querySelector("[data-close-btn]");
    this.prevBtn = this.el.querySelector("[data-prev-btn]");
    this.currentStepSpans = this.el.querySelectorAll("[data-current-step]");
    this.totalStepsSpans = this.el.querySelectorAll("[data-total-steps]");
    this.checkboxInputs = this.el.querySelectorAll("input[type='checkbox']");
    this.progressBar = this.el.querySelector("[data-progress-bar]");
    this.progressBarInner = this.progressBar.querySelector("[data-inner]");
    this.textInputs = this.el.querySelectorAll(
      "input[type='text'],input[type='email']"
    );
    this.radioInputs = this.el.querySelectorAll("input[type='radio']");
    this.fieldsets = this.el.querySelectorAll("fieldset");
    this.validationError = this.el.querySelector("[data-validation-error]");

    // Set total number of steps (question count)
    this.totalStepsSpans.forEach((span) => {
      span.innerText = WizardHelper.wizard.steps;
    });

    // Disable prev button initially
    this.togglePrevBtnDisabled(false);

    // Set progress bar to step 1
    this.updateProgressBar(1);

    // Attach event listeners
    this.attachEventListeners();

    // Ensure handleNextClick is called before the library's onClick method
    this.el.addEventListener(
      "click",
      (event) => {
        const isWizardButton = event.target.matches(
          `${WizardHelper.wizard.wz_buttons} ${WizardHelper.wizard.wz_button}`
        );
        const isFinishButton = event.target.matches(
          WizardHelper.wizard.wz_finish
        );

        if (isWizardButton && !isFinishButton) {
          this.handleNextClick(event);
        }

        if (isFinishButton) {
          this.handleSubmit(event);
        }
      },
      true
    );

    // Set wizard as ready to prevent re-initialization
    WizardHelper.wizardReady = true;
  }

  attachEventListeners = () => {
    this.radioInputs.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.handleRadioClick(radio);
      });
    });

    this.checkboxInputs.forEach((input) => {
      input.addEventListener("click", () => this.handleCheckboxClick(input));
    });

    this.checkboxInputs = this.el.querySelectorAll("input[type='checkbox']");
    this.checkboxInputs.forEach((input) => {
      input.addEventListener("change", () => this.handleCheckboxClick(input));
    });

    this.textInputs.forEach((input) => {
      input.addEventListener("blur", () => {
        this.handleValidation(input, { inputType: "single" });
      });
    });
    this.prevBtn.addEventListener("click", this.handlePrevClick);
    this.closeBtn.addEventListener("click", this.handleCloseClick);

    WizardHelper.wizard.update();
  };

  handleNextClick = () => {
    const currentStep = WizardHelper.wizard.getCurrentStep();
    const finalStep = WizardHelper.wizard.steps === currentStep + 1;
    this.isCheckboxChecked(currentStep);

    if (!this.checkboxChecked && !finalStep) {
      WizardHelper.wizard.lock();
      this.validationError.classList.remove("hide");
      return;
    }

    this.togglePrevBtnDisabled(true);
    this.updateStatus(currentStep + 2);
    this.updateProgressBar(currentStep + 2);
  };

  handlePrevClick = () => {
    const currentStep = WizardHelper.wizard.getCurrentStep();

    if (currentStep < 1) {
      this.togglePrevBtnDisabled(false);
      return;
    }

    WizardHelper.wizard.setCurrentStep(currentStep - 1);
    WizardHelper.wizard.update();

    this.updateStatus(currentStep);
    this.updateProgressBar(currentStep);

    if (currentStep - 1 === 0) this.togglePrevBtnDisabled(false);
  };

  updateStatus = (currentStep) => {
    this.currentStepSpans.forEach((span) => {
      span.innerText = currentStep;
    });
  };

  updateProgressBar = (step) => {
    const percent = (step / WizardHelper.wizard.steps) * 100;
    this.progressBarInner.style.width = `${percent}%`;
  };

  togglePrevBtnDisabled = (enable) => {
    if (enable) this.prevBtn.removeAttribute("disabled");
    else this.prevBtn.setAttribute("disabled", "");
  };

  handleCheckboxClick = (input) => {
    const currentStep = WizardHelper.wizard.getCurrentStep();
    const classes = input.parentElement.classList;
    if (input.checked) classes.add("checked");
    else classes.remove("checked");

    this.validationError.classList.add("hide");
    this.isCheckboxChecked(currentStep);
  };

  handleRadioClick = (input) => {
    const currentStep = WizardHelper.wizard.getCurrentStep();
    const classes = input.parentElement.classList;
    const previous = this.fieldsets[currentStep].querySelector(".checked");
    if (previous) {
      previous.classList.remove("checked");
    }
    if (input.checked) {
      classes.add("checked");
    }

    this.validationError.classList.add("hide");
    this.isCheckboxChecked(currentStep);
  };

  handleSubmit = () => {
    this.submitBtn = this.el.querySelector(".button.finish");
    this.handleValidation(null, { inputType: "multiple" });

    if (WizardHelper.wizard.locked) return;

    this.disableSubmitBtn();
    this.el.submit();
  };

  handleValidation = (input, { inputType }) => {
    // Case for single input validation
    if (inputType === "single") {
      this.textInputValidation(input);
    }

    // Case for multiple input validation
    if (inputType === "multiple") {
      this.textInputs.forEach((input) => {
        this.textInputValidation(input);
      });
    }
  };

  textInputValidation = (input) => {
    const parent = input.parentElement;

    if (!input.validity.valid || input.validity.typeMismatch) {
      parent.classList.add("has-error");
      WizardHelper.wizard.lock();
    } else {
      parent.classList.remove("has-error");
    }

    this.checkAllTextInputs();
  };

  checkAllTextInputs = () => {
    for (const input of this.textInputs) {
      if (!input.validity.valid || input.validity.typeMismatch) {
        WizardHelper.wizard.lock();
        return;
      }
    }

    // Only unlock if no text inputs are invalid
    WizardHelper.wizard.unlock();
  };

  // Determine if at least one checkbox is checked
  isCheckboxChecked = (currentStep) => {
    const currentFieldset = this.fieldsets[currentStep];
    const inputs = currentFieldset.querySelectorAll(
      "input[type='checkbox'], input[type='radio']"
    );
    this.checkboxChecked = Array.from(inputs).some((input) => input.checked);

    if (this.checkboxChecked && WizardHelper.wizard.locked) {
      WizardHelper.wizard.unlock();
    } else if (!this.checkboxChecked && !WizardHelper.wizard.locked) {
      WizardHelper.wizard.lock();
    }
  };

  handleCloseClick = () => window.history.back();

  disableSubmitBtn = () => {
    this.submitBtn.setAttribute("disabled", "");
    this.submitBtn.innerHTML = "<div class='spinner'></div>";
  };

  beforeRemove() {
    this.el.removeEventListener("click", this.handleNextClick);
    this.el.removeEventListener("click", this.handleSubmit);
    this.checkboxInputs.forEach((input) => {
      input.removeEventListener("click", this.handleCheckboxClick);
    });
    this.textInputs.forEach((input) => {
      input.removeEventListener("blur", this.handleValidation);
    });
    this.prevBtn.removeEventListener("click", this.handlePrevClick);
    this.closeBtn.removeEventListener("click", this.handleCloseClick);
  }
}

export default WizardHelper;
